import apiService from 'src/enviroment';

const billingService = {
  getBilling: (params) => apiService.get(
    `/segmentacion/maestros/facturasclases/?unidad_negocio_id=${params}`,
  ),
  getClasses: () => apiService.get('/segmentacion/maestros/facturas/'),
  postBilling: (params) => apiService.post('/segmentacion/maestros/facturasclases/', params),
  putBilling: (params) => apiService.put('/segmentacion/maestros/facturasclases/', params),
  deleteBilling: (params) => apiService.delete(
    `/segmentacion/maestros/facturasclases/?id=${params.UUID}&clase=${params.CLASE}&signo=${params.SIGNO}&signo_neto=${params.SIGNO_NETO}&unidad_negocio_id=${params.UNIDAD_NEGOCIO}`,
  ),
};

export default billingService;
